export interface TilesInterface {
  key: string;
  name?: string;
  isStatic?: boolean;
  height?: string;
  width?: string;
  padding?: string;
}

export const SideOldCockpitSideTiles: Array<TilesInterface> = [
  {
    key: '1',
    name: 'pulse',
    isStatic: true,
    width: 'initial',
    height: '50%'
  },
  {
    key: '2',
    name: 'real-date-time',
    isStatic: true,
    height: '25%',
    padding: '5px 0 0 0',
    width: 'initial'
  },
  {
    key: '3',
    name: 'logo',
    isStatic: true,
    height: '25%',
    padding: '5px 0 0 0',
    width: 'initial'
  }
];

export const DefaultOldCockpitTiles: Array<TilesInterface> = [
  { key: '4' },
  { key: '5' },
  { key: '6' },
  { key: '7' },
  { key: '8' },
  { key: '9' },
  { key: '10' },
  { key: '11' }
];

export const DefaultOldCockpitTilesForSpecialMode: Array<TilesInterface> = [
  { key: '4' },
  { key: '5' },
  { key: '6' },
  { key: '7' },
  { key: '8' },
  { key: '9' }
];

export const TutorialTiles: Array<TilesInterface> = [
  {
    key: '4',
    name: 'environment-3'
  },
  {
    key: '5',
    name: 'own-supply-of-energy'
  },
  {
    key: '6',
    name: 'energy'
  },
  {
    key: '7',
    name: 'energy-history'
  },
  {
    key: '8',
    name: 'digital-fields-of-action'
  },
  {
    key: '9',
    name: 'testing-waste-container'
  },
  {
    key: '10',
    name: 'smart-wifi'
  },
  {
    key: '11',
    name: 'amount-of-waste'
  }
];

export const SpecialTutorialTiles: Array<TilesInterface> = [
  { key: '4', name: 'city-info' },
  { key: '5', name: 'amount-of-waste' },
  { key: '6', name: 'digital-city-tour' },
  { key: '7', name: 'urban-trash-can' },
  { key: '8', name: 'current-weather' },
  { key: '9', name: 'upcoming-projects-1' }
];
